import { Col, Row } from "reactstrap";
import { AddIcon, ClearAllIcon, FilterIcon } from "../../utils/icon.utils";
import Search from "../../ui/Search";
import Button from "../../ui/Button";

export default function StockToolBar({
  handleAdd,
  handleFilterToggle,
  filteredValues,
  onFilterClear,
  onSearch,
  searchText = "",
  isSearched,
  handleSearchClear
}) {
  return (
    <Row className="align-items-center g-3 flex-column-reverse mb-3 flex-md-row">
      <Col md={4}>
        <Search
          name={"chassis"}
          onSubmit={onSearch}
          placeholder={"Chassis or Serial number"}
          defaultValue={searchText}
          isSearched={isSearched}
          handleClear={handleSearchClear}
        />
      </Col>
      <Col md={8}>
        <div className="d-flex align-items-center justify-content-end gap-1">
          <Button color="primary" icon={AddIcon} name="Add Stock" onClick={handleAdd} />
          <Button color="secondary" icon={FilterIcon} onClick={handleFilterToggle} />
          {!!filteredValues && (
            <Button color="danger" icon={ClearAllIcon} onClick={onFilterClear} />
          )}
        </div>
      </Col>
    </Row>
  );
}
